import type { IconSvgObject } from './types';

const NonBinaryIcon: IconSvgObject = [
  ["path", { d: "M20.4922 3.5L13.4922 10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.99219 15C2.99219 11.6863 5.67848 9 8.99219 9C12.3059 9 14.9922 11.6863 14.9922 15C14.9922 18.3137 12.3059 21 8.99219 21C5.67848 21 2.99219 18.3137 2.99219 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.9922 3L18.9922 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14.9922 5L20.9922 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default NonBinaryIcon;
